import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Layout from './components/Layout';
import Inventory from './components/Inventory';
import ECommerceInventory from './components/ECommerceInventory';
import ExternalOrders from './components/ExternalOrders';
import Orders from './components/Orders';
import OrderDetail from './components/OrderDetail';
import './App.css';
import './styles/StickyTableFix.css'; // Import after Bootstrap to override its styles
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrandingProvider } from './contexts/BrandingContext';
import baseTheme from './theme';

// Protected Route component
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return null; // or a loading spinner
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

// Role-based redirect component
function RoleBasedRedirect() {
  const { user, loading } = useAuth();
  
  if (loading || !user) {
    return null;
  }
  
  if (user.isRetail === true) {
    return <Navigate to="/products" replace />;
  } else {
    return <Navigate to="/inventory" replace />;
  }
}

function App() {
  return (
    <Router>
      <ThemeProvider theme={baseTheme}>
        <CssBaseline />
        <AuthProvider>
          <BrandingProvider>
            <div className="App">
              <Routes>
                {/* Public route */}
                <Route path="/login" element={<Login />} />
                
                {/* Protected routes */}
                <Route path="/" element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }>
                  <Route index element={<RoleBasedRedirect />} />
                  <Route path="products" element={<ECommerceInventory />} />
                  <Route path="inventory" element={<Inventory />} />
                  <Route path="external-orders" element={<ExternalOrders />} />
                  <Route path="orders" element={<Orders />} />
                  <Route path="orders/:orderId" element={<OrderDetail />} />
                  <Route path="*" element={<RoleBasedRedirect />} />
                </Route>
              </Routes>
            </div>
          </BrandingProvider>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
